$(document).ready(function(){

	// scroll
	$(window).scroll(function() {    
	    var scroll = $(window).scrollTop();

	    if (scroll >= 70) {
	        $(".ware_header").addClass("ware_shadow");
	    } else {
	        $(".ware_header").removeClass("ware_shadow");
	    }
	});

	// header navigation
	$(".ware_header .ware_nav li a").click(function(){
		$(this).parent().siblings().find("a").removeClass("on");
		$(this).addClass("on");
		
	});

	

	// search btn clicked 
	$(".ware_search .ware_txt_input").click(function(){
		$(".ware_search").addClass("on");

	});

	// .ware_txt_input 포커스 들어갔을시 .ware_search on빼기
	$(document).on("focusout",".ware_txt_input",function(){
	    $(".ware_search").removeClass("on");
	});

	// sub_nav클릭 이벤트
	$(".sub_nav > a").click(function(){
		$(this).parent().siblings().find("a").removeClass("on");
		$(this).addClass("on");

	});

});